import { LocalTrack } from './LocalTrack';
import { Requester } from './Requester';
import { Track } from './Track';

export type TrackRequestValue = string | Track;

export enum TrackRequestType {
  String,
  Track,
  Library,
}

export enum TrackRequestState {
  NotFound,
  FoundOne,
  FoundMultiple,
  Mapped,
  AutoMapped,
}

export type TrackRequestMessage = {
  value: string;
  date: string;
  id?: string;
};

export enum TrackRequesterPriorityValue {
  High = 'high',
  Normal = 'normal',
  Low = 'low',
}

export type TrackRequestPriority = {
  id?: string;
  value: TrackRequesterPriorityValue;
};

export interface TrackRequest<T = TrackRequestValue> {
  value: T;
  type: TrackRequestType;
  hash: string;
  id?: string;
  index?: number;
  date?: string;
  requesters?: Requester[];
  autoMapped?: boolean;
  skipAutoMap?: boolean;
  localId?: number;
  localTrack?: LocalTrack;
  foundLocalTracks?: LocalTrack[];
  isDeleted?: boolean;
  deleteDate?: string;
  messages?: TrackRequestMessage[];
  priorities?: TrackRequestPriority[];

  /** Playlist information for tracks imported from Spotify playlists */
  playlistInfo?: {
    name: string;
    image: string;
    id: string;
  };
}
